module.exports = __webpack_public_path__ + "images/bentley02bd31a55b641cae5a789278ba1779fd.png";